module.exports = __webpack_public_path__ + "img/77c61be.png";